export default "__VITE_ASSET__yOLaQ32n__"